<template>
<v-app style="background:#FBFBFB;text-align:justify;padding:5%;">
<v-btn text color="black" to="/">&lt;&nbsp;zur&uuml;ck</v-btn>

<h1>Datenschutzerklärung</h1><br/>

  <h2>1. Allgemeine Hinweise</h2>
  <p>
    Ich behandle Ihre
    personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften
    sowie dieser Datenschutzerklärung.
  </p>

  <h2>2. Verantwortlicher</h2>
  <p>
    Verantwortlich für die Datenverarbeitung auf dieser Website ist:
  </p>
  <p>
    Karobube<br />
    Simon Reuter<br />
    c/o IP-Management #9162<br />
    Ludwig-Erhard-Str. 18<br />
    20459 Hamburg<br/><br/>
    contact@karobube.com<br />
    06421 3800 306
    <br/>
<br/>Hierbei handelt es sich um eine ladungsfähige Nebenadresse zum Privatadressenschutz. Die Mitteilung der Rechnungs- und Meldeanschrift für den Geschäftsverkehr erfolgt auf Anfrage. Vielen Dank für Ihr Verständnis.
  </p>

  <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
  <p>
    Beim Besuch dieser Website werden durch den Hosting-Provider automatisch Informationen
    erfasst (Server-Logfiles). Dies sind:
  </p>
  <ul>
    <li>IP-Adresse</li>
    <li>Datum und Uhrzeit der Anfrage</li>
    <li>Browsertyp und -version</li>
    <li>Betriebssystem</li>
  </ul><br/>
  <p>
    Diese Daten dienen ausschließlich der technischen Bereitstellung und Sicherheit der Website.
    Eine Zusammenführung dieser Daten mit anderen Datenquellen erfolgt nicht.
  </p>

  <h2>4. Kontaktaufnahme</h2>
  <p>
    Wenn Sie mich per E-Mail oder Whatsapp kontaktieren, werden Ihre Angaben zwecks Bearbeitung der Anfrage
    gespeichert. Diese Daten werden nicht an Dritte weitergegeben.
  </p>

  <h2>5. Keine Cookies</h2>
  <p>
    Diese Website verwendet keine Cookies.
  </p>

  <h2>6. Keine Weitergabe an Dritte</h2>
  <p>
    Eine Übermittlung Ihrer persönlichen Daten an Dritte findet nicht statt, es sei denn,
    ich bin gesetzlich dazu verpflichtet.
  </p>

  <h2>7. Hosting</h2>
  <p>
    Die Website wird bei dem Hosting-Anbieter Netlify betrieben. Anbieter ist Netlify, Inc., 44 Montgomery Street, Suite 300, San Francisco, CA 94104, USA.<br/><br/>
    Netlify verarbeitet personenbezogene Daten (z. B. IP-Adressen, Logfiles) zur Bereitstellung der Website.<br/><br/>
    Die Verarbeitung erfolgt auf Grundlage eines Vertrags zur Auftragsverarbeitung gem&auml;&szlig; Art. 28 DSGVO.<br/><br/>
    Eine Daten&uuml;bermittlung in die USA kann nicht ausgeschlossen werden. Netlify verwendet Standardvertragsklauseln der EU-Kommission, um ein angemessenes Datenschutzniveau zu gew&auml;hrleisten.
  </p>

  <h2>8. Ihre Rechte</h2>
  <p>Sie haben jederzeit das Recht auf:</p>
  <ul>
    <li>Auskunft über Ihre gespeicherten Daten</li>
    <li>Berichtigung unrichtiger Daten</li>
    <li>Löschung Ihrer Daten</li>
    <li>Einschränkung der Verarbeitung</li>
    <li>Datenübertragbarkeit</li>
  </ul><br/>
  <p>
    Außerdem haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
  </p>

  <h2>9. Widerruf Ihrer Einwilligung</h2>
  <p>
    Sie können eine bereits erteilte Einwilligung jederzeit widerrufen.
  </p>

  <h2>10. SSL- bzw. TLS-Verschlüsselung</h2>
  <p>
    Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung („https“).
  </p>

  <h2>11. Aktualität und Änderungen</h2>
  <p>
    Diese Datenschutzerklärung ist aktuell gültig und hat den Stand: 13.04.2026.
  </p>
  <p>
    Ich behalte mir vor, sie bei Bedarf anzupassen.
  </p>
  </v-app>
</template>

<script>
export default {
  name: 'Impressum'
};
</script>

<style scoped>
.logo {
  width: 70%;
  max-width: 700px;
  margin: 5% 5% 2% 5%;
}
.bottom-right {
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin: 1% 1% 1%;
}
.text {
  color: white;
  max-width: 100%;
}
</style>
